'use strict';

module.exports = {
    FLOW_CHECKOUT_NAME: 'checkout',
    FLOW_CART_NAME: 'cart'
};
